import { useState, useEffect } from 'react';
import { useToasts } from '@blaze-react/toaster';
import { postContactMessages } from '../messages';

const handleMessageSubmit = (client, yachtData) => {
  const [submitState, setSubmitState] = useState(null);
  const [selectedContact, setSelectedContact] = useState(null);
  const { addToast } = useToasts();

  const handleSubmit = async selectedContact => {
    const { formValues, setFormValues } = submitState;

    await postContactMessages(client, formValues, yachtData, [selectedContact], addToast);

    setFormValues({
      name: '',
      email: '',
      message: ''
    });

    setSubmitState(null);
  };

  useEffect(() => {
    if (submitState === null) return;
    handleSubmit(selectedContact);
  }, [submitState, selectedContact]);

  return (givenSubmitState, givenSelectedContact) => {
    setSubmitState(givenSubmitState);
    setSelectedContact(givenSelectedContact);
  };
};

export default handleMessageSubmit;
